export const beforeFormTranslations = {
  en: {
    platformLabel: "Revimo Platform",
    welcomeTitle: "Welcome to your recovery space",
    welcomeDescription:
      "Before any exercise plan is assigned, we first need a short intake so Revimo can understand your issue and check for important warning signs.",
    requiredLabel: "Required before plan",
    intakeTitle: "Complete your intake form",
    intakeDescription:
      "This step helps identify the problem and collects important information to help personalize our plans for you.",
    physioTitle: "Do you have your personal physiotherapist?",
    physioDescription:
      "If your personal physiotherapist uses Revimo for Physios, you can connect the personalized plan created just for you. Enter the plan code below in the input field.",
    prePlanTitle: "Complete the pre-plan intake",
    prePlanButton: "Pre-plan intake",
    customPlanTitle: "Enter custom plan code:",
    customPlanPlaceholder: "AB-123-456-789",
  },
  sl: {
    platformLabel: "Platforma Revimo",
    welcomeTitle: "Dobrodošli v vašem prostoru za okrevanje",
    welcomeDescription:
      "Preden vam dodelimo načrt vaj, moramo najprej izvesti kratek uvodni vprašalnik, da Revimo razume vašo težavo in preveri pomembne opozorilne znake.",
    requiredLabel: "Obvezno pred načrtom",
    intakeTitle: "Izpolnite uvodni vprašalnik",
    intakeDescription:
      "Ta korak pomaga prepoznati težavo in zbrati pomembne informacije za bolj prilagojen načrt za vas.",
    physioTitle: "Ali imate svojega osebnega fizioterapevta?",
    physioDescription:
      "Če vaš osebni fizioterapevt uporablja Revimo za fizioterapevte, lahko povežete njegov prilagojen načrt, pripravljen posebej za vas. V spodnje polje vnesite kodo načrta.",
    prePlanTitle: "Izpolnite uvodni vprašalnik pred načrtom",
    prePlanButton: "Uvodni vprašalnik",
    customPlanTitle: "Vnesite kodo prilagojenega načrta:",
    customPlanPlaceholder: "AB-123-456-789",
  },
} as const;

export type BeforeFormLang = keyof typeof beforeFormTranslations;
